var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"toggle"},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('ToggleButton',{attrs:{"value":_vm.value,"sync":"","css-colors":""},on:{"input":function (value) { return _vm.$emit('input', value); }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }